<template>
  <header class="app-header">
    <div class="app-header__spacer"></div>

    <!-- Budget — the money icon. Primary entry point for the Budget section;
         there is deliberately no Budget group in the sidebar. -->
    <RouterLink
      v-if="canRoute('BudgetDashboard')"
      to="/Budget/Dashboard"
      class="app-header__btn"
      :class="{ 'app-header__btn--active': isBudgetRoute }"
      title="Budget"
      aria-label="Budget">
      <i class="bi bi-wallet2"></i>
    </RouterLink>

    <!-- Notifications inbox. Moved here out of the sidebar; the unread poll
         came with it unchanged. -->
    <RouterLink
      v-if="isAuthenticated"
      to="/Devices/Notifications"
      class="app-header__btn"
      :class="{ 'app-header__btn--active': isNotifRoute }"
      title="Notifications"
      aria-label="Notifications">
      <i class="bi bi-bell"></i>
      <span v-if="unreadCount > 0" class="app-header__badge">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    </RouterLink>
  </header>
</template>

<script>
import api from '@/store/services/api';

export default {
  name: 'AppHeader',

  data() {
    return {
      unreadCount: 0,
      unreadTimer: null
    }
  },

  mounted() {
    this.fetchUnread();
    // Light fallback poll; route changes also refresh it (see watch).
    this.unreadTimer = setInterval(this.fetchUnread, 60000);
  },

  beforeUnmount() {
    if (this.unreadTimer) clearInterval(this.unreadTimer);
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    isBudgetRoute() {
      return (this.$route?.path || '').startsWith('/Budget')
    },
    isNotifRoute() {
      return (this.$route?.path || '') === '/Devices/Notifications'
    }
  },

  methods: {
    canRoute(name) {
      return this.$store.getters.canRoute(name)
    },
    async fetchUnread() {
      if (!this.isAuthenticated) { this.unreadCount = 0; return; }
      try {
        const res = await api.get('/notifications/unread-count');
        this.unreadCount = res.data?.unread ?? 0;
      } catch (e) { /* non-fatal — badge just stays as-is */ }
    }
  },

  watch: {
    '$route.path'() {
      // Refresh the unread badge on navigation (e.g. after visiting the inbox).
      this.fetchUnread()
    }
  }
}
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 4px;
  margin-bottom: 6px;
  background: linear-gradient(135deg, #27253f, #605a6d);
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.app-header__spacer { flex: 1; }

.app-header__btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  color: rgba(255,255,255,0.85);
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}

.app-header__btn:hover {
  background: rgba(255,255,255,0.12);
  color: #fff;
}

.app-header__btn--active {
  background: rgba(255,255,255,0.16);
  color: #fff;
}

.app-header__btn i { font-size: 19px; }

.app-header__badge {
  position: absolute;
  top: 2px;
  right: 0;
  background: #e53935;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  min-width: 17px;
  height: 17px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

/* On mobile the app already has a fixed top bar; keep this one clear of it. */
@media (max-width: 768px) {
  .app-header {
    height: 44px;
    margin-bottom: 4px;
  }
}
</style>
